export const aiNewsCategory = {
  id: "ai-news",
  path: "/blog/category/ai-news",
  label: "AI news",
  title: "AI news, explained.",
  description: "AI news, explained clearly.",
} as const;

export type BlogCategory = typeof aiNewsCategory.id;

/**
 * Hub for comparisons between other AI agents: `<name>-alternatives` and
 * `<name>-vs-<name>` pages. `/compare` keeps the Maito-vs pages.
 */
export const aiEmployeesHub = {
  path: "/compare/best-ai-employees",
  title: "Weighing AI agents for support and engineering?",
  description:
    "AI agents in Slack are new, and they're hard to tell apart. Pick the product you're weighing to see its alternatives, or two products to compare them head to head: whether it can handle a support escalation, what it does with your code, where it works, and what it costs.",
} as const;
